// extracted by mini-css-extract-plugin
export default {"workTypeContainer":"workType_workTypeContainer__hTDsx","code":"workType_code__J81Oy","name":"workType_name__MwfEy","typeCode":"workType_typeCode__Hh-wJ"};